/**
 * Equipment Types and Codes for FinPac and Other Equipment Financing Lenders
 * This file serves as a single source of truth for equipment types and their corresponding codes
 * Used by both the client-side form and the server-side lender submission modules
 */

// Array of equipment types for dropdown selection
export const equipmentList = [
  "VEHICLE-Van/Box/Delivery",
  "VEHICLE-TRUCK/TRK W/SLP",
  "VEHICLE-Special Purpose",
  "VEHICLE-Dump Truck",
  "VEHICLE-Garbage Truck",
  "VEHICLE-Limousine",
  "VEHICLE-Passenger Van/Bus",
  "VEHICLE-Pickup/Flatbed",
  "VEHICLE-Sweeper(Titled)",
  "VEHICLE-Tow Truck",
  "VEHICLE-TRUCK DAYCAB",
  "VEHICLE-Bucket/Crane Truck",
  "VEHICLE-Water Truck",
  "OFFICE EQUIPMENT",
  "COPIER",
  "OFFICE FURNITURE",
  "MAILING EQUIPMENT",
  "CHIROPRACTIC EQUIPMENT",
  "DENTAL EQUIPMENT",
  "HOME HEALTH CARE EQUIP",
  "ULTRASOUND EQUIP",
  "LAB TEST EQUIPMENT",
  "OPTICAL EQUIPMENT",
  "PHYSICAL THERAPY EQUIP",
  "X-RAY EQUIPMENT",
  "PHYSICIANS MEDICAL EQUIP",
  "LASERS - MEDICAL/COSMETIC",
  "LASERS - MEDICAL/COSMETIC",
  "KITCHEN EQUIPMENT",
  "ESPRESSO MACHINES",
  "FOOD & BEVERAGE SERVERS",
  "HOOD/FIRE SUPPRESSION SYSTEMS",
  "RESTAURANT FURNITURE",
  "TELEPHONE SYSTEM",
  "COMMUNICATION EQUIPMENT",
  "INDUSTRIAL EQUIPMENT",
  "CONSTRUCTION YELLOW IRON",
  "CONCRETE FORMING EQUIP",
  "AIR COMPRESSOR",
  "LIGHTING - PORTABLE",
  "GENERATOR / EMISSION CONTROL",
  "STORAGE TANKS",
  "SCAFFOLDING",
  "LOGGING/SKIDDER NO TITLE",
  "SURVEY / ENGINEERING EQ",
  "DIESEL FILTERS",
  "AUXILARY POWER UNITS",
  "CONSTRUCTION-Other Equipment",
  "COMPUTER HW/ROUTER/SERVER",
  "SOFTWARE ONLY",
  "PRINTER/PLOTTER/SCANNER",
  "COMPUTER LCD DISPLAY CA",
  "COMPUTER SYSTEM HW/SW PKG",
  "SIGN MAKING EQUIPMENT",
  "COMPUTER TESTING & REPAIR",
  "POINT OF SALE EQUIPMENT",
  "CARD VERIFICATION EQUIP",
  "CARNIVAL/AMUSEMENT RIDES",
  "ENTERTAINMENT EQUIPMENT",
  "PLAYGROUND EQUIPMENT",
  "SPORTS & REC - FIXED",
  "INFLATE AMUSEMENT EQUIP",
  "PRINT & DUPLICATE EQUIP",
  "MILK PRODUCTION EQUIPMENT",
  "AG-Harvest & Planting   Equipment",
  "AG-Farm Tractor",
  "AG-Other Equipment",
  "AUTOMOTIVE TESTING EQUIP",
  "AUTOMOTIVE-Car Wash",
  "AUTOMOTIVE-Hoist/Lifts",
  "AUTOMOTIVE-Paint Booth",
  "PIPE BENDERS",
  "TRUCK MOUNTED LIFT/RACK",
  "TRUCK SCALE",
  "AUTOMOTIVE REPAIR EQUIP",
  "EXERCISE/FITNESS EQUIP",
  "GYMNASTICS EQUIPMENT",
  "SALON FIXTURES",
  "TANNING BED BULB",
  "OTHER HEALTH/BEAUTY EQUIP",
  "MICRODERMABRASION EQUIP",
  "TANNING BOOTH SPRAY-ON",
  "MOLDS/FORMS/DIES",
  "SEWING & EMBROIDERY EQUIP",
  "PACKAGE/SHRINK WRAP EQUIP",
  "SILK SCREENING EQUIPMENT",
  "MANUFACTURING EQUIPMENT",
  "WINE BARRELS",
  "FUEL DISPENSERS",
  "HEATING",
  "SOLAR PANELS",
  "LED LIGHTING",
  "SIGNS & AWNINGS",
  "CONTAINERS & DRY STORAGE",
  "WATER SYS-NON IRRIGATION",
  "FURNISHINGS",
  "DRY CLEANING EQUIPMENT",
  "LAUNDRY EQUIPMENT",
  "ENGRAVER",
  "MACHINE TOOLS",
  "CARPET CLEANING MACHINE",
  "DUCT CLEANING MACHINE",
  "JANITORIAL EQUIPMENT",
  "LANDSCAPING & MOWERS",
  "PRESSURE WASHER",
  "SPRAY COATING MACHINE",
  "OTHER MAINTENANCE EQUIP",
  "CONVEYOR SYSTEM",
  "FORKLIFT",
  "PALLET DISMANTLER",
  "PLATFORM/MAN LIFT",
  "OTHER MATERIAL HANDLING",
  "MINING & DRILLING EQUIP",
  "SURVEILLANCE EQUIPMENT",
  "CAMERA & PHOTO PROCESSING",
  "TV/MOVIE/SOUND EQUIPMENT",
  "TRAILER-Dump/Chip/Grain",
  "TRAILER-Dry Van",
  "TRAILER-Low Boy",
  "TRAILER-Flat Bed",
  "TRAILER-Log",
  "TRAILER-Office/Titled",
  "TRAILER-Pup/Transfer",
  "TRAILER-Car Hauling",
  "TRAILER-Refrigerated",
  "TRAILER-Travel",
  "TRAILER-Tank",
  "TRAILER-Utility",
  "TRAILER-Other",
  "TRAILER-Goose Neck",
  "TRAILER-Drop Neck",
  "TRAILER-Concession",
  "TRAILER-Chipper",
  "VENDING EQUIPMENT",
  "VIDEO GAMES",
  "WASTE/RECYCLE CONTAINERS",
  "TOILETS (PORTABLE)",
  "WASTE OIL FURNACE",
  "OTHER WASTE/RECYCLE EQUIP",
  "WOODWORKING EQUIPMENT",
  "Restricted"
];

// Array of equipment codes corresponding to equipment types
export const equipmentCodeList = [
  "001.002",
  "001.003",
  "001.011",
  "001.016",
  "001.017",
  "001.019",
  "001.023",
  "001.024",
  "001.026",
  "001.027",
  "001.029",
  "001.030",
  "001.031",
  "002.001",
  "002.002",
  "002.016",
  "002.019",
  "003.012",
  "003.013",
  "003.018",
  "003.019",
  "003.021",
  "003.023",
  "003.025",
  "003.026",
  "003.027",
  "003.029",
  "003.029",
  "004.001",
  "004.003",
  "004.012",
  "004.014",
  "004.016",
  "005.001",
  "005.020",
  "009.001",
  "009.012",
  "009.016",
  "009.028",
  "009.029",
  "009.030",
  "009.031",
  "009.033",
  "009.035",
  "009.036",
  "009.037",
  "009.038",
  "009.044",
  "010.001",
  "010.002",
  "010.003",
  "010.006",
  "010.015",
  "010.016",
  "010.017",
  "011.002",
  "011.014",
  "013.011",
  "013.015",
  "013.021",
  "013.028",
  "013.032",
  "014.018",
  "015.012",
  "015.014",
  "015.021",
  "015.023",
  "016.002",
  "016.015",
  "016.022",
  "016.024",
  "016.027",
  "016.033",
  "016.034",
  "016.038",
  "017.013",
  "017.014",
  "017.016",
  "017.018",
  "017.019",
  "017.020",
  "017.021",
  "018.016",
  "018.018",
  "018.019",
  "018.020",
  "018.023",
  "018.024",
  "019.012",
  "019.021",
  "019.022",
  "019.023",
  "019.027",
  "019.029",
  "019.032",
  "019.034",
  "020.015",
  "020.017",
  "021.014",
  "021.023",
  "022.013",
  "022.015",
  "022.016",
  "022.017",
  "022.019",
  "022.020",
  "022.022",
  "023.012",
  "023.015",
  "023.016",
  "023.019",
  "023.020",
  "024.012",
  "025.014",
  "026.012",
  "026.022",
  "027.011",
  "027.012",
  "027.013",
  "027.014",
  "027.015",
  "027.016",
  "027.017",
  "027.018",
  "027.019",
  "027.020",
  "027.021",
  "027.022",
  "027.023",
  "027.024",
  "027.025",
  "027.027",
  "027.028",
  "028.014",
  "028.015",
  "029.012",
  "029.016",
  "029.019",
  "029.020",
  "030.022",
  "088.999"
];

/**
 * Gets the equipment code for a given equipment type
 * @param {string} equipmentType - The equipment type to look up
 * @returns {string} - The corresponding equipment code, or "088.999" (Restricted) if not found
 */
export const getEquipmentCodeFromEquipmentType = (equipmentType) => {
  const index = equipmentList.findIndex(value => value === equipmentType);
  
  if (index !== -1) {
    return equipmentCodeList[index];
  }
  
  // Default to "Restricted" if not found
  return "088.999";
};

// Helper for frontend to get equipment options for select dropdown
export const getEquipmentTypeOptions = () => {
  return equipmentList.map(type => ({
    value: type,
    label: type
  }));
}; 